import { MarketAttributes } from './utils';

export const CYBER_MARKETS: MarketAttributes[] = [
  {
    name: 'Coalition',
    method: 'API',
    isIncumbent: true,
    status: 'quoted',
  },
  {
    name: 'Arch',
    method: 'API',
    status: 'declined',
  },
  {
    name: 'Markel',
    method: 'email',
    status: 'awaiting',
  },
  {
    name: 'Chubb',
    method: 'portal',
    status: 'awaiting',
    portalUrl: 'https://agentview.chubb.com/dashboard',
  },
  {
    name: 'CFC',
    method: 'API',
    status: 'quoted',
  },
  {
    name: 'GAIG',
    method: 'email',
    status: 'awaiting',
  },
];
